import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Products
export const getProducts = (publishedOnly = false) =>
  api.get(`/products${publishedOnly ? '?published_only=true' : ''}`).then(r => r.data);

export const getProduct = (id) =>
  api.get(`/products/${id}`).then(r => r.data);

export const createProduct = (data) =>
  api.post('/products', data).then(r => r.data);

export const updateProduct = (id, data) =>
  api.put(`/products/${id}`, data).then(r => r.data);

export const deleteProduct = (id) =>
  api.delete(`/products/${id}`).then(r => r.data);

export const reorderProducts = (items) =>
  api.put('/products/reorder/bulk', items).then(r => r.data);

// Articles
export const getArticles = (publishedOnly = false) =>
  api.get(`/articles${publishedOnly ? '?published_only=true' : ''}`).then(r => r.data);

export const getArticle = (id) =>
  api.get(`/articles/${id}`).then(r => r.data);

export const createArticle = (data) =>
  api.post('/articles', data).then(r => r.data);

export const updateArticle = (id, data) =>
  api.put(`/articles/${id}`, data).then(r => r.data);

export const deleteArticle = (id) =>
  api.delete(`/articles/${id}`).then(r => r.data);

// Settings
export const getSettings = () =>
  api.get('/settings').then(r => r.data);

export const updateSettings = (data) =>
  api.put('/settings', data).then(r => r.data);

// File upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

// Build image URL from storage path
export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API}/files/${path}`;
};
